import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
import { ChevronRight } from 'lucide-react';
const paths = [['Repository secret', 'cloud access'], ['Identity misconfiguration', 'privileged access'], ['External exposure', 'sensitive systems'], ['Cloud permission chain', 'production data'], ['AI prompt injection', 'restricted content'], ['Unverified remediation', 'recurring exposure'], ['Internal reachability', 'high-value assets'], ['Control failure', 'exploitable risk']];
const facts = ['A vulnerability is not always a business risk.', 'A misconfiguration is not always exploitable.', 'A closed ticket does not always mean risk is gone.'];
export function CorePromise() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-232">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-233">
        <SectionLabel number="06" label="Core Promise" className="mb-8" data-id="element-234" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-235">
          <div className="lg:col-span-8" data-id="element-236">
            <SectionHeading size="2xl" className="tracking-[-0.04em]" data-id="element-237">
              Not findings.
              <br data-id="element-238" />
              <span className="text-[#1a8fd4]" data-id="element-239">Paths.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4 space-y-3" data-id="element-240">
            {facts.map((fact, i) => <p key={i} className="text-base text-white/60 leading-relaxed" data-id="element-241">
                {fact}
              </p>)}
          </div>
        </div>

        {/* Path examples */}
        <div className="rounded-2xl bg-gradient-to-br from-[#0a0d12] to-[#070a0e] border border-white/5 overflow-hidden" data-id="element-242">
          <div className="px-8 py-5 border-b border-white/5 flex items-center justify-between" data-id="element-243">
            <span className="font-mono text-xs uppercase tracking-widest text-white/40" data-id="element-244">
              Example Path Patterns
            </span>
            <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-245">
              {paths.length} chains
            </span>
          </div>
          <div className="divide-y divide-white/5" data-id="element-246">
            {paths.map((path, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} className="group px-8 py-5 flex items-center gap-4 hover:bg-white/[0.02] transition-colors" data-id="element-247">
                <span className="font-mono text-xs text-white/30 w-8" data-id="element-248">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="flex-1 flex items-center gap-3 flex-wrap" data-id="element-249">
                  <span className="text-base md:text-lg text-white/80" data-id="element-250">
                    {path[0]}
                  </span>
                  <ChevronRight className="w-4 h-4 text-[#1a8fd4]/40 group-hover:text-[#1a8fd4] group-hover:translate-x-0.5 transition-all" data-id="element-251" />
                  <span className="text-base md:text-lg text-white font-medium" data-id="element-252">
                    {path[1]}
                  </span>
                </div>
                <span className="font-mono text-xs text-white/30 group-hover:text-[#1a8fd4] transition-colors" data-id="element-253">
                  validate →
                </span>
              </motion.div>)}
          </div>
        </div>

        <p className="mt-8 text-lg text-white/60 max-w-2xl" data-id="element-254">
          Periscan shows <span className="text-white" data-id="element-255">the path</span>, the
          evidence, the fix, and the verification.
        </p>
      </div>
    </section>;
}